import OrderChangeRequested from '../../../application/order/events/OrderChangeRequested';
import State from '../../../application/core/State';
import OrderValidationResult from './OrderValidationResult';
import { Validator } from './Validator';
import StockError from './error';

// tslint:disable-next-line:typedef
export default (configuration: Validator[]) => (state: State, event: OrderChangeRequested): OrderValidationResult => {
    return configuration.reduce(
        (result: OrderValidationResult, validator: Validator): OrderValidationResult => {
            const current = validator(
                {
                    ...event,
                    value: result.value
                },
                state
            );
            if (current.notification !== StockError.Null) {
                return {
                    notification: current.notification,
                    value: current.value
                };
            } else {
                return result;
            }
        },
        {
            notification: StockError.Null,
            value: event.value
        }
    );
};



// WEBPACK FOOTER //
// ./src/domain/orders/validators/validate.ts